import React from 'react'
import PropTypes from 'prop-types'

import { App, Header, Sidebar, Content, PageWrapper, AICatalystSubHeader } from 'views/layouts'
import { AICatalystWrapper } from 'views/containers'
import { Container } from 'views/components'

function OappDocsChat() {
  return (
    <App>
      <Sidebar />
      <Header subHeader={<AICatalystSubHeader />} pageTitle="AI Catalyst" />

      <Content>
        <PageWrapper>
          <Container>
            <AICatalystWrapper model="oapp_docs_chat" />
          </Container>
        </PageWrapper>
      </Content>
    </App>
  )
}

// Default Props
OappDocsChat.defaultProps = {
  actions: {},
  filters: {},
  ui: {},
}

// Proptypes Validation
OappDocsChat.propTypes = {
  actions: PropTypes.shape({
    setShowHeaderLoader: PropTypes.func,
    setIsPageTableUpdated: PropTypes.func,
    showAlert: PropTypes.func,
  }),
  filters: PropTypes.shape({
    whitelistingFilters: PropTypes.instanceOf(Object),
  }),
  ui: PropTypes.shape({
    isPageTableUpdated: PropTypes.bool,
  }),
}

export default OappDocsChat
